import type { Activity } from "@lib/activity";
import { type LandingPageChoice } from "@lib/landing";
import { type Ticket } from "@lib/ticket";
import { useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
import connectionScript from "./connection";
import { hashedEmailAtom } from "@/lib/state";
import { useAtom } from "jotai";
import { hashEmail } from "@/lib/email.client";

type SnapProps = {
  activity: Activity;
  code: string;
  page: LandingPageChoice;
  ticket?: Ticket;
};

type SnapTrFun = (event: string, param: string, options?: unknown) => void;

declare global {
  interface Window {
    snaptr?: SnapTrFun;
  }
}

export function Snap({ activity, code, page, ticket }: SnapProps) {
  const [cookies] = useCookies([`sopost-purpose_${activity.id}`]);
  const tracked = useRef(false);
  const [hashedEmail] = useAtom(hashedEmailAtom);

  const cookie = cookies[`sopost-purpose_${activity.id}`] as string | undefined;
  const enabled = !(!cookie || cookie === "rejected");

  useEffect(() => {
    if (tracked.current || !enabled) return;
    if (!window.snaptr) connectionScript();

    tracked.current = true;
    const snaptr = window.snaptr as unknown as SnapTrFun;

    const trackAsync = async () => {
      const toTrack =
        hashedEmail ||
        (ticket?.address?.email ? await hashEmail(ticket.address.email) : null);

      snaptr("init", code, { user_hashed_email: toTrack });
      snaptr("track", "PAGE_VIEW");

      // Track the form submission if on the completion page and
      // hashedEmail is available (which means the form was just submitted,
      // rather than a page refresh).
      if (page == "completion" && hashedEmail) {
        snaptr("track", "SIGN_UP");
      }
    };

    void trackAsync();
  }, [enabled]);

  return <></>;
}
